import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useHeaderTitleVariant } from '../useHeaderTitleVariant/useHeaderTitleVariant.js';

var _excluded = ["lineClamp"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Hook to generate props for the HeaderTitle component
 * @param lineClamp
 * @param props - HeaderTitleProps with partial typing
 * @returns Object containing memoized headerTitleProps
 */
var useHeaderTitle = function useHeaderTitle(_ref) {
  var lineClamp = _ref.lineClamp,
    props = _objectWithoutProperties(_ref, _excluded);
  var variant = useHeaderTitleVariant();
  return {
    headerTitleProps: _objectSpread(_objectSpread({
      variant: variant,
      textAlign: 'start',
      lineClamp: lineClamp
    }, props), lineClamp && {
      title: props === null || props === void 0 ? void 0 : props.children
    })
  };
};

export { useHeaderTitle };
//# sourceMappingURL=useHeaderTitle.js.map
